module.exports = "/_next/static/images/MakeEveryInteractionMeaningful-b228de45eebe1d21c0ba2c8701450218.webp";